import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import {
  FeedConversationResponse,
  FeedConversationsResponse,
  SmartAssistantFeedPayloadItemsDTO,
} from '../../dtos/glai.dto';

@Injectable({
  providedIn: 'root',
})
export class GlaiFeedService {
  constructor(private apiService: APICoreService) {}

  getConversations(
    payload: SmartAssistantFeedPayloadItemsDTO
  ): Observable<FeedConversationsResponse> {
    return this.apiService.getRequest('ai/admin/conversations', payload);
  }

  getConversation(
    conversationId: number
  ): Observable<FeedConversationResponse> {
    return this.apiService.getRequest(
      `ai/admin/conversation/${conversationId}`
    );
  }
}
